<template>
  <div class="contacts-wrap"
       v-infinite-scroll="handleLoadMore"
       infinite-scroll-distance="50"
       infinite-scroll-immediate-check="false">
    <div class="card">
      <div class="card-body">
        <form @submit.prevent="searchContact">
          <div class="md-form input-group">
            <input type="text" class="form-control" v-model.trim="searchText" placeholder="Contacts/Messages">
            <div class="input-group-append">
              <button v-if="!loadingFlag"
                      class="btn btn-md btn-default m-0 px-3"
                      type="submit"
              >
                <mdb-icon icon="search"/>&nbsp;Search
              </button>
              <button v-if="loadingFlag"
                      class="btn btn-md btn-default m-0 px-3"
                      type="submit"
              ><div class="spinner-border text-light" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              </button>
            </div>
          </div>
        </form>

        <div class="mid-wrap d-flex justify-content-between align-items-center"
             :class="{'mid-wrap-searching':isShowSearchResult }"
             v-if="isContactsLoaded"
        >
          <span v-if="!isShowSearchResult"> Show: {{contactsStore.length}} / {{contactTotal}}</span>
          <div class="mid-item" v-if="isShowSearchResult">
            <span>Search Result</span>
          </div>
          <div class="mid-item btn-wrap" v-if="isShowSearchResult">
            <div class="switch-btn"
                 :class="{'switch-active' : currentTab == 0}"
                 @click="showContactsResult"
            >
              CONTACTS
            </div>
            <div class="switch-btn"
                 :class="{'switch-active' : currentTab == 1}"
                 @click="showMessagesResult"
            >
              MESSAGES
            </div>
          </div>
          <div class="mid-item">
            <span class="read-all" @click="readAllMessages">Mark all as read</span>
          </div>
        </div>

        <contact-list v-if="!currentTab" :contactList="contactShadowList" :old_contacts="contactShadowList"/>
        <message-list v-if="currentTab" :chat-records="chatRecordsShadowList"/>
        <!-- 加载更多 -->
        <div v-if="loading" class="d-flex justify-content-center align-items-center">
          <div class="spinner-border text-light" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactList from '@/components/ContactList'
import MessageList from '@/components/MessageList'
import mdbIcon from "mdbvue/src/components/Content/Fa";
import user from "../Services/UserService";
import dayjs from "dayjs";
import badgeService from "@/Services/badgeService";
import Vue from "vue"
import contactsStore from "@/store/contactsStore";
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

const userService = new user();

const {EventBus} = require("../Bus.js");

export default {
  components: {
    mdbIcon,
    ContactList,
    MessageList
  },
  data() {
    return {
      listLimit: 50,
      contactTotal: 0,
      searchText: "",
      contacts: [],
      loadingFlag: false,
      channel_id: "",
      name: "",
      old_contacts: [],

      isShowSearchResult: false, // 是否顯示tab按鈕
      isContactsLoaded: true, // 首屏聯絡人是否請求完成
      chat_records: [], // 聊天記錄列表
      loading: 0, // 加載中
    };
  },
  computed: {
    isNormalTab() {
      return this.$route.params?.type === 'search-contacts';
    },
    currentTab() { // 選項卡下標
      if (this.$route.params.type == 'search-contacts' || this.$route.params.type == 'default') {
        return 0
      } else {
        return 1
      }
    },
    contactShadowList() {
      const badgeList = badgeService.list();

      return this.contactsStore.map((row) => {
        return {
          ...row,
          unread: badgeList.includes(row.uid) ? 1 : 0,
          isNamed: true,
          unix: dayjs(row.time).unix(),
        }
      }).sort((a, b) => {
        if (b.unread != a.unread)  {
          return b.unread - a.unread;
        }
        return b.unix - a.unix;
      }).slice(0, this.listLimit);
    },
    contactsStore() {
      if (this.searchText) {
        return this.contacts || [];
      }
      return Array.from(contactsStore.items);
    },
    chatRecordsShadowList() {
      return this.chat_records.map((row) => {
        return {
          ...row,
          unix: dayjs(row.time).unix(),
        }
      }).sort((a, b) => {
        return b.unix - a.unix;
      }).slice(0, this.listLimit);
    },
    listAvailableCount() {
      const paramsType = this.$route.params?.type;
      switch (paramsType) {
        case 'default':
        case 'search-contacts':
          return this.contactsStore.length || 0;
        case 'search-message':
          return this.chat_records.length || 0;
      }

      return 0;
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        this.listLimit = 50;
        if (this.loadingFlag) {
          return;
        }
        let paramsType = this.$route.params.type

        let search = to.query.s || '';
        this.searchText = search;

        if (from && (to.query.s == from.query.s)) {
          return
        }

        if (paramsType != 'default') {
          this.loadingFlag = true;
          this.isShowSearchResult = false;
          Promise.all([
              this.fetchContacts(search),
              this.fetchChatRecords(search),
          ]).finally(() => {
            this.loadingFlag = false;
            this.isShowSearchResult = true;
          });
        } else {
          this.isShowSearchResult = false;
        }
      },
      immediate: true
    },
    searchText(val) {
      if (this.$route.params.type != 'default' && !val) {
        this.contacts = [];
        this.chat_records = [];
        this.doContactsRouterAction('push', 'default');
      }
    },
  },
  methods: {
    fetchContactTotal() {
      userService.total()
        .then((data) => {
          this.contactTotal = data.total || 0;
      })
    },
    searchContact() {
      if (this.searchText) {
        this.doContactsRouterAction('push', 'search-contacts');
      } else {
        this.doContactsRouterAction('push', 'default');
      }
    },
    // 切換tab
    showContactsResult() {
      this.doContactsRouterAction('replace', 'search-contacts');
    },
    showMessagesResult() {
      this.doContactsRouterAction('replace', 'search-message');
    },
    // 请求联系人列表contacts
    fetchContacts(search = null) {
      this.isContactsLoaded = false;
      return userService.users({search}).then((data) => {
        this.contacts = data;
      })
      .finally(() => {
        this.isContactsLoaded = true;
      })
    },
    // 請求聊天記錄數據
    fetchChatRecords(searchQuery) {
      return userService.search_chat_record(searchQuery).then(res => {
        // console.log('聊天記錄', res)
        this.chat_records = res
      })
    },
    // 点击全部消息已读
    readAllMessages() {
      userService.read_all().then(res => {
        this.contacts = this.contacts.map((row) => {
          return {
            ...row,
            unread: 0,
          }
        })
      })
      EventBus.dispatchMarkedAllAsRead();
    },
    doContactsRouterAction(routerType, paramType) {
      let search = this.searchText || ''
      let query = {}

      if (!!search) {
        query.s = search
      }
      this.$router[routerType]({
        name: 'contacts',
        params: {
          type: paramType
        },
        query
      })
    },

    handleLoadMore() {
      if (this.listLimit >= this.listAvailableCount) {
        return;
      }
      clearTimeout(this.loading);
      this.loading = setTimeout(() => {
        this.listLimit += 50;
        this.loading = 0;
      }, 500);
    },
  },

  mounted() {
    this.fetchContactTotal();
  }
};
</script>

<style>
.del_user {
  margin-left: 10px;
  color: red;
}

.unread_btn.unread_btn.unread_btn {
  padding: 0.5rem 0.6rem;
}
</style>
